import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../../environments/environment";
import {SendMessageDto} from "../../../../auto-generated-server-dtos/claim/messages/send-message-dto";

@Injectable({
  providedIn: 'root'
})
export class SendMessageService {

  constructor(private httpClient: HttpClient) { }

  sendMessage(message: string, claimId: number) {
    let sendMessageDto: SendMessageDto = {
      message: message,
      claimId: claimId
    };
    return this.httpClient.post(`${environment.apiServer}/SendMessage`, sendMessageDto);
  }
}
